/**
 * @generated SignedSource<<29ea437fee2709b5f728f6e08798b18d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UserAdminEditGroupDeviceScreenDeleteMutation$variables = {
  id: string;
  storeId?: string | null;
};
export type UserAdminEditGroupDeviceScreenDeleteMutation$data = {
  readonly store: {
    readonly sharedMobileDevice: {
      readonly delete: {
        readonly id: string;
      };
    } | null;
  };
};
export type UserAdminEditGroupDeviceScreenDeleteMutation = {
  response: UserAdminEditGroupDeviceScreenDeleteMutation$data;
  variables: UserAdminEditGroupDeviceScreenDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "storeId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "storeId"
      }
    ],
    "concreteType": "StoreMutations",
    "kind": "LinkedField",
    "name": "store",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
          }
        ],
        "concreteType": "SharedMobileDeviceMutations",
        "kind": "LinkedField",
        "name": "sharedMobileDevice",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SharedMobileDevice",
            "kind": "LinkedField",
            "name": "delete",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UserAdminEditGroupDeviceScreenDeleteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UserAdminEditGroupDeviceScreenDeleteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "552540a1cbd1527ba8e599b52239e3d4",
    "id": null,
    "metadata": {},
    "name": "UserAdminEditGroupDeviceScreenDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation UserAdminEditGroupDeviceScreenDeleteMutation(\n  $id: ID!\n  $storeId: ID\n) {\n  store(id: $storeId) {\n    sharedMobileDevice(id: $id) {\n      delete {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c61cd02a4a4820f3a5a3f49d24ef83d0";

export default node;
